import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { DataTableListComponent } from './data-table-list.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MxCommonsModule, MxLanguageTranslationModule } from 'mx-commons';
import { ConfirmationPopoverModule } from 'angular-confirmation-popover';
import { SharedComponentModule } from 'src/app/shared/components/shared-component.module';
import { PaginationModule } from 'ngx-bootstrap/pagination';


@NgModule({
	declarations: [DataTableListComponent],
	imports: [
		HttpClientModule,
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MxCommonsModule,
		MxLanguageTranslationModule,
		ConfirmationPopoverModule,
		SharedComponentModule,
		BsDatepickerModule,
		PaginationModule
	],
	exports: [DataTableListComponent]
})
export class DataTableListModule { }
